import styles from './index.css';

// Please replace, if IE11-support isn't required any longer.
//import {useFormContext} from 'react-hook-form';
import {useFormContext} from 'react-hook-form/dist/react-hook-form.ie11';

import * as React from 'react';
import {get, without} from 'lodash';
import classNames from 'classnames';

import {Option} from '../../Definitions';
import CheckIndicator from '../CheckIndicator';

type CheckboxGroupProps = {
	name: string;
	options: Option[];
	required?: boolean;
	className?: string;
    visibleElements?: any;
}
export default (props: CheckboxGroupProps) => {
	const {name = '', required = false, options = [], className, visibleElements = null} = props;

	if (!name) {
		console.warn('Missing prop "name" for CheckboxGroup.');
		return null;
	}

	if (!options.length) {
		console.warn('Missing "options" for CheckboxGroup.');
		return null;
	}

	const {register, errors, getValues, setValue, watch} = useFormContext();
	const isMultiple = options.length > 1;
	const checkedValue = get(getValues({nest: true}), name, isMultiple ? [] : '');
	const isInvalid = Boolean(get(errors, name));

	watch(name);

	const updateValue = (value: number|string) => {
		let updatedValue = value;

		if (isMultiple) {
			updatedValue = checkedValue.includes(value) ?
			without(checkedValue, value) :
			checkedValue.concat(value);
		} else {
			updatedValue = value === checkedValue ?
			'' :
			value
		}

		setValue(name, updatedValue, true);
	};

	const isChecked = (value: number|string) => isMultiple ?
		checkedValue.includes(value) :
		checkedValue === value;

	return (
		<div className={classNames(
			styles.checkboxgroup,
			isMultiple && styles.isMultiple,
			isInvalid && styles.isInvalid,
			required && !checkedValue.length && styles.isRequired,
			className
		)}>
			{
				options.map(({value, label}) => (
					<div
						key={value}
						className={classNames(
                            styles.option,
                            Array.isArray(visibleElements)
                                ? (!visibleElements.includes(value) && styles.hidden)
                                : styles.regular
                        )}
					>
						<label
							onClick={() => updateValue(value)}
							className={styles.label}
						>
							<CheckIndicator
								isChecked={isChecked(value)}
								isInvalid={isInvalid}
								look="square"
								required={required && !checkedValue.length} // Just set, if no element of group is checked.
								className={styles.checkIndicator}
							/>
							{label||value}
						</label>
						<input
							type="checkbox"
							name={name}
							ref={register({required})}
							value={value}
						/>
					</div>
				))
			}
		</div>
	);
}
